import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_ExtensionItemEdition = _resolveComponent("ExtensionItemEdition")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    rounded: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex justify-space-between" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
          _createVNode(_component_v_menu, {
            hover: "",
            location: "start"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn_icon, _mergeProps({
                icon: "$fa-gear",
                size: "small"
              }, props), null, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, { density: "compact" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.editExtension()), ["stop"]))
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("$oss-edit")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("Editer")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, {
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.removeExtensionDialog()), ["stop"]))
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("$oss-trash")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("Supprimer")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_subtitle, {
        textContent: _toDisplayString(_ctx.url)
      }, null, 8, ["textContent"]),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_chip, {
            label: "",
            variant: "flat",
            rounded: "pill",
            textContent: _toDisplayString(_ctx.extensionType),
            size: "small"
          }, null, 8, ["textContent"])
        ]),
        _: 1
      }),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.removeDialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.removeDialog) = $event)),
        title: "Supprimer l'extension",
        onValid: _ctx.removeExtension,
        validTitle: "Supprimer",
        error: true,
        width: "60vw"
      }, {
        default: _withCtx(() => [
          _cache[8] || (_cache[8] = _createTextVNode(" Voulez-vous supprimer l'extension ")),
          _createElementVNode("i", null, _toDisplayString(_ctx.name), 1),
          _cache[9] || (_cache[9] = _createTextVNode(" ? "))
        ]),
        _: 1
      }, 8, ["modelValue", "onValid"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.editDialog,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editDialog) = $event)),
        title: "Ajouter une extension",
        actions: _ctx.dialogAction,
        width: "60vw"
      }, {
        default: _withCtx(() => [
          (_ctx.editDialog)
            ? (_openBlock(), _createBlock(_component_ExtensionItemEdition, _mergeProps({
                key: 0,
                actions: _ctx.dialogAction
              }, _ctx.$props, { onUpdated: _ctx.updateExtensionItem }), null, 16, ["actions", "onUpdated"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "actions"])
    ]),
    _: 1
  }))
}